import React, {useEffect, useState} from 'react';
import './App.css';
import Header from "./components/Header";
import {createTheme, Fab, ThemeProvider} from "@mui/material";
import AboutCourse from "./components/AboutCourse";
import Footer from "./components/Footer";
import ForWhomCourse from "./components/ForWhomCourse";
import WhatAwaitsSection from "./components/WhatAwaitsSection";
import LecturersSection from "./components/LecturesSection";
import StudentOrganizations from "./components/StudentOrganizations";
import HowToParticipate from "./components/HowToParticipate";
import Question from "./components/Question";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import {darken} from "@mui/material/styles";
import Directions from "./components/Directions";

const theme = createTheme({
    typography: {
        h1: {
            fontFamily: 'Kyiv Type Serif',
            fontSize: '32px'
        },
        h2: {
            fontFamily: 'Kyiv Type Sans',
            fontSize: '20px'
        },
        button: {
            fontFamily: 'Kyiv Type Sans',
            fontSize: '14px',
            fontWeight: 'regular'
        }
    },
    components: {
        MuiTypography: {
            styleOverrides: {
                root: {
                    color: '#062159'
                },
            },
        },
    },
});

function App() {
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 500) {
                setShowButton(true);
            } else {
                setShowButton(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <ThemeProvider theme={theme}>
            <Header/>
            <AboutCourse/>
            <Directions/>
            <ForWhomCourse/>
            <WhatAwaitsSection/>
            <LecturersSection/>
            <StudentOrganizations/>
            <HowToParticipate/>
            <Question/>
            <Footer/>

            {showButton && (
                <Fab
                    aria-label="scroll to top"
                    sx={{
                        position: 'fixed',
                        bottom: 16,
                        right: 16,
                        zIndex: 1000,
                        backgroundColor: '#BA6973',
                        color: '#fff',
                        '&:hover': {
                            backgroundColor: darken('#BA6973', 0.1),
                        },
                    }}
                    onClick={scrollToTop}
                >
                    <ArrowUpwardIcon/>
                </Fab>
            )}
        </ThemeProvider>
    );
}

export default App;
